module.exports = __webpack_public_path__ + "fonts/calibri-bold.8879a4ca.ttf";